import React, { useState } from "react";
import { FiSun, FiMoon } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import StatsSVG from "../../assets/images/stats.svg";

const Toolbar = ({ toggleDarkMode, isDarkMode }) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const navigate = useNavigate();

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const logout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  const username = localStorage.getItem("UN") || "Unknown";
  const companyName = localStorage.getItem("CN") || "Unknown";
  const email = localStorage.getItem("EMAIL") || "Unknown";

  return (
    <header className="relative z-50 flex items-center justify-between h-[5vh] px-4 bg-primary-light dark:bg-primary-dark text-text-primary-light dark:text-text-primary-dark shadow-md">
      {/* Left Section */}
      <div className="flex items-center gap-4">
        <img src={StatsSVG} alt="Company Logo" className="w-6 h-6" />
        <span className="text-md font-semibold hidden sm:block">
          {companyName}
        </span>
      </div>

      {/* Center Banner */}
      {isBannerVisible && (
        <div
          className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 dark:bg-gray-900 px-6 py-2 -mt-5 sm:px-3.5"
          style={{
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
          }}
        >
          {/* Fondo decorativo */}
          <div
            className="absolute left-[max(-7rem,calc(50%-52rem))] -z-10  transform-gpu blur-2xl"
            aria-hidden="true"
          >
            <div
              className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
              style={{
                clipPath:
                  "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
              }}
            />
          </div>
          <div
            className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            aria-hidden="true"
          >
            <div
              className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
              style={{
                clipPath:
                  "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
              }}
            />
          </div>
          {/* Contenido */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <p className="text-sm text-gray-900 dark:text-gray-100">
              <strong className="font-semibold">Beta Version:</strong> Some
              features may still be under development.{" "}
              <a
                href="https://stats.dr.avsteams.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-blue-500"
              >
                Access the previous version here.
              </a>
            </p>
          </div>
          <div className="flex flex-1 justify-end">
            <button
              onClick={() => setIsBannerVisible(false)}
              className="text-gray-900 dark:text-gray-100 hover:text-gray-500 focus:outline-none"
            >
              <span className="sr-only">Dismiss</span>
              <IoClose size={18} />
            </button>
          </div>
        </div>
      )}

      {/* Right Section */}
      <div className="flex items-center gap-4">
        {/* Dark Mode Toggle */}
        <button
          onClick={toggleDarkMode}
          className="p-1 rounded-md bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
        >
          {isDarkMode ? <FiSun size={20} /> : <FiMoon size={20} />}
        </button>

        {/* User Menu */}
        <div className="relative">
          <button
            onClick={toggleUserMenu}
            className="flex items-center focus:outline-none"
          >
            <img
              src="https://tsensor.online/wp-content/uploads/2020/04/avatar-icon-png-105-images-in-collection-page-3-avatarpng-512_512.png"
              alt="User Avatar"
              className="w-8 h-8 rounded-full"
            />
          </button>

          {isUserMenuOpen && (
            <div className="absolute right-0 top-full mt-2 z-[100] bg-white dark:bg-gray-700 shadow-lg rounded-lg w-64">
              <div className="px-4 py-2">
                <p className="text-base font-medium">{username}</p>
                <p className="text-sm text-gray-500 dark:text-gray-300">
                  {email}
                </p>
              </div>

              <hr className="border-gray-200 dark:border-gray-600" />

              <ul>
                <li>
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                    disabled
                  >
                    Edit profile
                  </button>
                </li>

                <li>
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                    onClick={logout}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Toolbar;
